/*************************************************/
/* 3rd Party                                     */
/*************************************************/
window.$ = window.jQuery = require("jquery");
require("jquery-validation");
require("jquery-validation-unobtrusive");
// import { mmenu } from "./partials/mmenu.js";
// import { inview } from "./partials/inview.js";

/*************************************************/
/* Partials                                      */
/*************************************************/
import { intersectionObservation } from "./partials/intersectionObservation.js";
import { news } from "./partials/news.js";
import { video } from "./partials/video.js";
import { header } from "./partials/header.js";
import { search } from "./partials/search.js";
import { statistic } from "./partials/statistic.js";
import { slider } from "./partials/slider.js";
import { countdown } from "./partials/countdown.js";
import { collapsedText } from "./partials/collapsedText.js";
import { stickySidebar } from "./partials/stickySidebar.js";
import { accordion } from './partials/accordion.js';
import { searchbar } from "./partials/searchbar.js";
import { cookies } from "./partials/cookies.js";
import { menu } from "./partials/menu.js";


/*************************************************/
/* Vue                                           */
/*************************************************/
import Vue from "vue";
import VueRouter from "vue-router";
import newsEvents from "./vue/newsEvents.vue";
import quizApp from "./vue/quiz.vue";

const appNewsItems = "#app-news-event";

if (document.querySelectorAll(appNewsItems).length) {

    const router = new VueRouter({
        mode: "history"
    });
    Vue.use(VueRouter);

    if (document.querySelectorAll(appNewsItems).length) {
        var pageId = document.querySelector(appNewsItems).dataset.pageid;
        var products = new Vue({
            el: appNewsItems,
            data: {
                pageId: pageId
            },
            render: h => h(newsEvents),
            router
        });
    }
}

const quizAppElement = "#app-quiz";

if (document.querySelectorAll(quizAppElement).length) {

    if (document.querySelectorAll(quizAppElement).length) {
        var vm = document.querySelector(quizAppElement).dataset.vm;
        var quiz = new Vue({
            el: quizAppElement,
            data: {
                vm: vm,
                url: window.location.href
            },
            render: h => h(quizApp)
        });
    }
}

const tooltips = document.querySelectorAll(".tooltip");

if (tooltips.length > 0) { // Ensure at least one tooltip exists
    tooltips.forEach(function (tooltip) {
        tooltip.addEventListener("click", function () {
            // Toggle the open class on click
            this.classList.remove("tooltip-open");
            this.style = "pointer-events:none";
            setTimeout(() => {
                this.style.pointerEvents = "";
            }, 200);
        });
    });
}

// const scrollArrow = document.querySelector(".scroll-arrow");
// if (scrollArrow) {
//     scrollArrow.addEventListener("click", function () {
//         window.scrollBy({
//             top: window.innerHeight - 150, // Scrolls down by one viewport height
//             behavior: 'smooth' // Smooth scrolling animation
//         });
//     })
// }

const scrollArrow = document.querySelector(".scroll-arrow");

function isAtBottom() {
  return window.innerHeight + window.scrollY >= document.body.offsetHeight - 2;
}

function toggleArrowVisibility() {
  if (isAtBottom()) {
    scrollArrow.classList.add("hidden");
  } else {
    scrollArrow.classList.remove("hidden");
  }
}

if (scrollArrow) {
  scrollArrow.addEventListener("click", function () {
    window.scrollBy({
      top: window.innerHeight - 150,
      behavior: 'smooth'
    });
  });

  window.addEventListener("scroll", toggleArrowVisibility);
  window.addEventListener("resize", toggleArrowVisibility);

  // Run on load in case we're already at bottom
  toggleArrowVisibility();
}


/*************************************************/
/* Global variables                              */
/*************************************************/
const $body = $("body"),
    bodyLoadingClass = "is-loading",
    currentCulture = $("html").attr("lang");

/*************************************************/
/* Init                                          */
/*************************************************/
$(document).ready(function () {

    //Handle scroll to submitted form element
    const formSubmittedElement = document.getElementById("umbraco-forms-form-submitted--clienti");
    if (formSubmittedElement) {
        window.scrollTo(0, formSubmittedElement.closest('.form-item').offsetTop);
    }

    // mmenu();
    // inview();
    intersectionObservation();
    news($body, bodyLoadingClass, currentCulture);
    video();
    header($body);
    search();
    statistic();
    slider();
    countdown();
    collapsedText();
    accordion();
    searchbar($body);
    stickySidebar();
    cookies();
    menu();
});